$(document).ready(function () {
  var codeDiv = $('.js-code');
  var codeInput = codeDiv.find('input');
  var validFeedbackHint = codeDiv.find('.valid-feedback');
  var invalidFeedbackHint = codeDiv.find('.invalid-feedback');

  function displaySuccess() {
    codeInput.removeClass('is-invalid');
    invalidFeedbackHint.addClass('d-none');
    codeInput.addClass('is-valid');
    validFeedbackHint.removeClass('d-none');
  }

  function displayFailure() {
    codeInput.removeClass('is-valid');
    codeInput.addClass('is-invalid');
    invalidFeedbackHint.removeClass('d-none');
    validFeedbackHint.addClass('d-none');
  }

  codeInput.on('input', function () {
    const codeValue = this.value;
    if (codeValue.length > 3) {
      $.ajax({
        type: 'GET',
        url: codeInput.data('url'),
        data: '&[code]=' + codeValue,
        dataType: 'json',
        success: function () {
          displaySuccess();
        },
        error: function () {
          displayFailure();
        },
      });
    }
  });
});
